import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import qString from "query-string";
import { Link } from "react-scroll";

const CategoryListHeader = (props) => {
  const location = useLocation();

  const shouldShowReadMore = (loc) => {
    let qs = qString.parse(loc.search);
    if (!!qs.p && qs.p > 1) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div className="insideheader headerAllVendors">
      <h1>
        {location?.pathname.includes("/services/")
          ? `${props.category_name}`
          : `${props.category_name} Companies`}
      </h1>
      <ul>
        <li>
          <span className="number">
            {!!props.review_counts && props.review_counts.case_studies}
          </span>{" "}
          Case Studies
        </li>
        <li>
          <span className="number">
            {!!props.review_counts && props.review_counts.testimonials}
          </span>{" "}
          Testimonials
        </li>
        <li>
          <span className="number">
            {!!props.review_counts && props.review_counts.videos}
          </span>{" "}
          Customer Videos
        </li>
      </ul>
      {!!props.category_text ? (
        <p>{props.category_text}</p>
      ) : (
        <p>{`Find the best ${props.category_name} companies for your business. Read reviews, case studies, and customer success stories, and watch first-hand customer videos.`}</p>
      )}

      {props.learn_tab &&
        props.learn_tab.show_learn_lab &&
        shouldShowReadMore(location) && (
          <span className="btn_more">
            <Link
              activeclassName="active"
              to="learn"
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
            >
              {`What to Look For In ${props.category_name}`}
            </Link>
          </span>
        )}
    </div>
    // <section>
    //   <div className="insideheader headerAllVendors">
    //     <div className="container-fluid">
    //       <div className="left">
    //         <h1>{`${props.category_name} Companies`}</h1>
    //         <div className="vendor_count">
    //           <ul>
    //             <li>{`${
    //               !!props.review_counts && props.review_counts.case_studies
    //             } Case Studies`}</li>
    //             <li>{`${
    //               !!props.review_counts && props.review_counts.testimonials
    //             } Testimonials`}</li>
    //             <li>{`${
    //               !!props.review_counts && props.review_counts.videos
    //             } Customer Videos`}</li>
    //           </ul>
    //         </div>
    //       </div>
    //       <div className="right">
    //         <p>{props.category_text}</p>
    //         {props.learn_tab && props.learn_tab.show_learn_lab && (
    //           <span className="read_more">
    //             <Link
    //               activeclassName="active"
    //               to="learn"
    //               spy={true}
    //               smooth={true}
    //               offset={0}
    //               duration={500}
    //             >
    //               Read More
    //             </Link>
    //           </span>
    //         )}
    //       </div>
    //     </div>
    //   </div>
    // </section>
  );
};

export default CategoryListHeader;
